import type { Plugin } from "vue";
import { config } from "@fortawesome/fontawesome-svg-core";
import { SmakeUiPlugin } from "@smakecloud/smake-ui";
import { icons } from "~/utils/icons";
// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false;
// eslint-disable-next-line no-restricted-exports
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(SmakeUiPlugin as Plugin, {
        icons,
    });
});
